import { useCallback, useEffect, useState, createRef, useRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import dataDE from 'data.json'
import dataFR from 'data-fr.json'
import BarChart from 'components/BarChart'
import { nest } from 'd3-collection'

interface WrapperProps {
  isMobile: boolean
  colorMode?: string
}

const EuGains = ({
  tenant,
  colorMode,
  titleText,
}: {
  tenant?: object
  colorMode?: string
  titleText?: string
}) => {
  const [isMobile, setIsMobile] = useState(false)
  const [activeTooltip, setActiveTooltip] = useState(-1)
  const [linkedText, setLinkedText] = useState('')

  const data = (tenant as { lang: string }).lang == 'fr' ? dataFR : dataDE

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <Container>
      <Wrapper
        isMobile={isMobile}
        colorMode={colorMode}
        className={isMobile ? 'mobile' : 'desktop'}
      >
        <h4
          dangerouslySetInnerHTML={{
            __html: titleText ? titleText : '',
          }}
          lang='de'
        />

        <div className='graphic-wrapper'>
          <BarChart
            data={{
              id: {
                title: 'ID (Rechtspopulisten, Rechtsextreme)',
                old: 59,
                new: 99,
              },
              ekr: {
                title: isMobile
                  ? 'EKR\n(Konservative, Nationalisten, Rechtspopulisten)'
                  : 'EKR (Konservative, Nationalisten, Rechtspopulisten)',
                old: 68,
                new: 86,
              },
              evp: {
                title: 'EVP (Christdemokraten, Konservative)',
                old: 177,
                new: 181,
              },
              linke: {
                title: isMobile
                  ? 'Linke\n(Sozialisten, Linkspopulisten, Kommunisten)'
                  : 'Linke (Sozialisten, Linkspopulisten, Kommunisten)',
                old: 37,
                new: 39,
              },
              s_d: {
                title: 'S&D (Sozialdemokraten, Progressive)',
                old: 140,
                new: 134,
              },
              f_s: {
                title: 'F/S (Fraktionslose, meist rechte Parteien)',
                old: 50,
                new: 39,
              },
              re: {
                title: 'RE (Liberale, Zentristen)',
                old: 102,
                new: 89,
              },
              g_efa: {
                title: 'G/EFA (Grüne, Regionalparteien)',
                old: 72,
                new: 48,
              },
            }}
            colorMode={colorMode}
          />
        </div>
        <Source>
          Quelle:{' '}
          <a href={'https://www.foederalist.eu/p/europawahl-umfragen.html'}>
            foederalist.eu
          </a>
        </Source>
      </Wrapper>
    </Container>
  )
}

const Container = styled.div`
  background-color: transparent;
`

const Wrapper = styled.div<WrapperProps>`
  max-width: 640px;
  margin: 0 auto;
  padding: 0 0 0.5rem;
  margin-bottom: 3rem;

  h4 {
    font-size: 1.8rem;
    line-height: 2.4rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.7rem;
      line-height: 2.2rem;
    }
    margin-top: 0;
  }
  .graphic-wrapper {
  }
`

const Source = styled.div`
  margin-top: -1rem;
  font-size: 1.2rem;
  color: var(--gray-3);
  a {
    display: inline-block;
    color: var(--meta-data);
  }
`

export default EuGains
